// Menu articolo del preventivo (creazione e modifica): ricerca su
// item/get-all a pagine da 30, la successiva quando si scorre in fondo
// [sc-48920]. Spec: docs/superpowers/specs/2026-09-29-sc-48920-ricerca-articolo-design.md §5.1

import axiosInstance from "@/axiosInstance";
import {
  PAGINA_RICERCA,
  altrePagine,
  testoConteggio,
  unisciPagina,
} from "@/utilities/ricercaArticoli";

export default {
  data() {
    return {
      filteredItems: [],
      itemsLoading: false,
      ricercaArticoli: { testo: "", pagina: 0, totale: 0, altre: false },
      // una sola risposta vale: quella dell'ultima richiesta
      ricercaArticoliRichiesta: 0,
      // [sc-49299] finestra «Crea articolo»
      showCreaArticolo: false,
    };
  },
  computed: {
    // [sc-49299] il testo cercato diventa il nome del nuovo articolo, ma non
    // l'etichetta di un articolo già scelto
    nomeNuovoArticolo() {
      return this.newItem?.itemId ? "" : (this.searchQueryItem || "").trim();
    },
    conteggioArticoli() {
      return testoConteggio(
        this.filteredItems.length,
        this.ricercaArticoli.totale
      );
    },
  },
  methods: {
    // [sc-49299] articolo appena creato: si sceglie come uno della ricerca,
    // poi quantità e «Aggiungi»
    onArticoloCreato(item) {
      if (!item?.id) return;
      this.filteredItems = [
        item,
        ...this.filteredItems.filter((i) => i.id !== item.id),
      ];
      this.selectItem(item);
    },
    // [sc-49389] «Crea articolo» dalla tendina senza risultati: si chiude la
    // tendina e si apre la stessa finestra del link sotto il campo
    creaArticoloDaRicerca(chiudiTendina) {
      if (typeof chiudiTendina === "function") chiudiTendina();
      this.showCreaArticolo = true;
    },
    // nuova ricerca: si riparte da pagina 1
    fetchItems(q) {
      return this.caricaPaginaArticoli((q || "").trim(), 1);
    },
    // fine della tendina: pagina successiva della stessa ricerca
    caricaAltriArticoli() {
      if (this.itemsLoading || !this.ricercaArticoli.altre) return;
      return this.caricaPaginaArticoli(
        this.ricercaArticoli.testo,
        this.ricercaArticoli.pagina + 1
      );
    },
    async caricaPaginaArticoli(search, page) {
      const richiesta = ++this.ricercaArticoliRichiesta;
      this.itemsLoading = true;
      try {
        const { data } = await axiosInstance.get("/item/get-all", {
          params: {
            page,
            limit: PAGINA_RICERCA,
            ...(search ? { search } : {}),
          },
        });
        if (richiesta !== this.ricercaArticoliRichiesta) return;
        this.filteredItems =
          page === 1
            ? data.results || []
            : unisciPagina(this.filteredItems, data.results);
        this.ricercaArticoli = {
          testo: search,
          pagina: page,
          totale: Number(data.pagination?.totalItems) || 0,
          altre: altrePagine(data.pagination),
        };
      } catch (err) {
        if (richiesta !== this.ricercaArticoliRichiesta) return;
        // [sc-49389] item/get-all risponde 404 quando non trova niente: è una
        // ricerca vuota, non un errore. Alla prima pagina si svuota la tendina
        // (prima restavano i risultati della ricerca precedente); più avanti
        // si tiene quello caricato e non si chiede altro.
        if (err?.response?.status === 404) {
          if (page === 1) {
            this.filteredItems = [];
            this.ricercaArticoli = {
              testo: search,
              pagina: 1,
              totale: 0,
              altre: false,
            };
          } else {
            this.ricercaArticoli = { ...this.ricercaArticoli, altre: false };
          }
          return;
        }
        console.error(err);
      } finally {
        if (richiesta === this.ricercaArticoliRichiesta)
          this.itemsLoading = false;
      }
    },
  },
};
